import React from 'react'
import BaseComponent from '@base/BaseComponent'
import CSS from './index.module.css'

class GLOrderCouponSuccess extends BaseComponent {
	itemPress() {
		this.props.itemPress && this.props.itemPress()
	}

	render() {
		const style = this.props.style || {}
		const title = this.props.title || '下单送券'
		const tags = this.props.tags || []

		// console.log('========= GLOrderCouponSuccess style', style)

		if (tags.length === 0) {
			return null
		}

		return (
			<div className={CSS.coupon} style={style} onClick={this.itemPress.bind(this)}>
				<div className={CSS.left}>
					<img
						src='https://publicdev.oss-cn-beijing.aliyuncs.com/icon/common/orderCoupon.png'
						alt=''
					/>
				</div>
				<div className={CSS.middle}>
					<p className={CSS.middleTitle}>{title || ''}</p>
					<div className={CSS.middleInner}>
						{tags.map((item, index) => {
							return <p key={index}>{item.tagName || ''}</p>
						})}
					</div>
				</div>
				<div className={CSS.right}>
					<p>去看看</p>
				</div>
			</div>
		)
	}
}

export default GLOrderCouponSuccess
